import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function SafeIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M17.95 16.9V19.9C17.95 20.95 17.05 21.85 16 21.85C14.95 21.85 14.05 20.95 14.05 19.9V16.9C13.45 16.6 13.15 16.15 12.85 15.55H2.5C1.75 15.55 1 16.15 1 17.05V22.3C1 27.1 4.9 31 9.7 31H22.3C27.1 31 31 27.1 31 22.3V17.05C31 16.15 30.25 15.55 29.5 15.55H19.15C18.85 16 18.4 16.6 17.95 16.9Z"
        fill="currentColor"
      />
      <path
        d="M22.3 1H9.7C4.9 1 1 4.9 1 9.7V11.65C1 12.55 1.75 13.15 2.5 13.15H12.55C12.85 11.2 14.8 9.7 17.05 10.3C18.25 10.6 19.15 11.65 19.6 12.85V13.15H29.5C30.25 13.15 31 12.55 31 11.65V9.7C31 4.9 27.1 1 22.3 1Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
